var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-container" },
    [
      _c(
        "DxDataGrid",
        {
          attrs: {
            "data-source": _vm.dados,
            "show-borders": true,
            "show-row-lines": true,
            "show-column-lines": true,
            "column-auto-width": false,
            "allow-column-reordering": true,
            "allow-column-resizing": true,
            "row-alternation-enabled": true,
            "word-wrap-enabled": false,
            "key-expr": "id",
          },
          on: { "selection-changed": _vm.onSelectionChanged },
        },
        [
          _c("DxColumnChooser", { attrs: { enabled: true, mode: "select" } }),
          _vm._v(" "),
          _c("DxExport", {
            attrs: {
              enabled: true,
              "allow-export-selected-data": _vm.modoSelecao === "multiple",
            },
          }),
          _vm._v(" "),
          _c("DxSearchPanel", {
            attrs: { visible: true, width: 240, placeholder: "Buscar..." },
          }),
          _vm._v(" "),
          _c("DxFilterRow", { attrs: { visible: true } }),
          _vm._v(" "),
          _c("DxHeaderFilter", { attrs: { visible: true } }),
          _vm._v(" "),
          _c("DxPaging", { attrs: { "page-size": 50 } }),
          _vm._v(" "),
          _c("DxPager", {
            attrs: {
              "show-page-size-selector": true,
              "allowed-page-sizes": [20, 50, 100, 200],
              "show-info": true,
              "show-navigation-buttons": true,
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              "data-field": "Filial",
              caption: "Filial",
              width: 120,
              alignment: "left",
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              "data-field": "Almoxarifado",
              caption: "Almoxarifado",
              width: 150,
              alignment: "left",
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              "data-field": "CodigoReferencia",
              caption: "Cód. Referência",
              width: 120,
              alignment: "left",
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              "data-field": "Produto",
              caption: "Item",
              width: 200,
              alignment: "left",
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              "data-field": "Variacao",
              caption: "Variação",
              width: 150,
              alignment: "left",
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              "data-field": "Lote",
              caption: "Lote",
              width: 120,
              alignment: "left",
              visible: _vm.mostrarColunaLote,
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              "data-field": "DataValidade",
              caption: "Validade",
              "data-type": "date",
              width: 110,
              alignment: "center",
              visible: _vm.mostrarColunaLote,
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              "data-field": "Estoque",
              caption: "Quantidade",
              "data-type": "number",
              format: "#,##0.####",
              width: 120,
              alignment: "right",
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              "data-field": "Unidade",
              caption: "Unidade",
              width: 90,
              alignment: "center",
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              "data-field": "Tipo",
              caption: "Situação",
              width: 120,
              alignment: "center",
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              "data-field": "Origem",
              caption: "Origem",
              width: 180,
              alignment: "left",
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              "data-field": "NumeroDocumento",
              caption: "Documento",
              width: 160,
              alignment: "left",
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              "data-field": "HandleOrigem",
              caption: "Handle Origem",
              width: 100,
              alignment: "center",
              visible: false,
            },
          }),
          _vm._v(" "),
          _c("DxColumn", {
            attrs: {
              "data-field": "HandleLote",
              caption: "Handle Lote",
              width: 100,
              alignment: "center",
              visible: false,
            },
          }),
          _vm._v(" "),
          _c(
            "DxSummary",
            [
              _c("DxTotalItem", {
                attrs: {
                  column: "Estoque",
                  "summary-type": "sum",
                  "display-format": "Total: {0}",
                  "value-format": "#,##0.####",
                },
              }),
              _vm._v(" "),
              _c("DxTotalItem", {
                attrs: {
                  "summary-type": "count",
                  "display-format": "Registros: {0}",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("DxSelection", {
            attrs: {
              mode: _vm.modoSelecao,
              "show-check-boxes-mode":
                _vm.modoSelecao === "multiple" ? "always" : "none",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }